export default __webpack_public_path__ + "static/tab02-0e79fed52ab08e18d177eab874fbf134.png";